import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import FooterLegal from "./FooterLegal";
import FooterNav from "./FooterNav";
import LanguageSwitcher from "./LanguageSwitcher";
import { StyledPageFooter } from "./styles";
import { Footer, LegalDataType, NavDataType } from "./types";

const SiteFooter = ({
  brand,
  showNavigation,
  localizedBasePaths,
  defaultLocale,
  locales,
  rootDomain,
  title,
  ...rest
}: Footer) => {
  const isLanguageSelectorVisible = locales.length > 1 && localizedBasePaths;

  const { allFooterNavigationItem, legalContent } = useStaticQuery(graphql`
    {
      allFooterNavigationItem {
        nodes {
          name
          navigationItems {
            name
            to
          }
        }
      }
      legalContent {
        legalName
        legalNotice
      }
    }
  `);

  const navData: NavDataType = allFooterNavigationItem?.nodes;

  const legalData: LegalDataType = {
    ...legalContent,
    id: brand,
  };

  return (
    <>
      {(isLanguageSelectorVisible || showNavigation) && (
        <StyledPageFooter {...rest}>
          {isLanguageSelectorVisible && (
            <LanguageSwitcher
              localizedBasePaths={localizedBasePaths}
              defaultLocale={defaultLocale}
              locales={locales}
              rootDomain={rootDomain}
              title={title}
            />
          )}
          {showNavigation && (
            <>
              {navData && <FooterNav navData={navData} />}
              {legalData && <FooterLegal legalData={legalData} />}
            </>
          )}
        </StyledPageFooter>
      )}
    </>
  );
};

export default SiteFooter;
